import { forwardRef } from 'react';
import MaterialTypography, { TypographyProps } from '@mui/material/Typography';

export const Typography = forwardRef<HTMLDivElement, TypographyProps>(
    (props, ref) => {
        return (
            <MaterialTypography
                ref={ref}
                data-testid={'Typography-container'}
                {...props}
            />
        );
    }
);

export default Typography;
